/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform User API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserAuthorityType,
    UserAuthorityTypeFromJSON,
    UserAuthorityTypeFromJSONTyped,
    UserAuthorityTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateUserAuthoritiesResponse
 */
export interface UpdateUserAuthoritiesResponse {
    /**
     * UserId of updated user
     * @type {string}
     * @memberof UpdateUserAuthoritiesResponse
     */
    userId: string;
    /**
     * 
     * @type {Array<UserAuthorityType>}
     * @memberof UpdateUserAuthoritiesResponse
     */
    userAuthorities: Array<UserAuthorityType>;
}

export function UpdateUserAuthoritiesResponseFromJSON(json: any): UpdateUserAuthoritiesResponse {
    return UpdateUserAuthoritiesResponseFromJSONTyped(json, false);
}

export function UpdateUserAuthoritiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserAuthoritiesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'userAuthorities': ((json['userAuthorities'] as Array<any>).map(UserAuthorityTypeFromJSON)),
    };
}

export function UpdateUserAuthoritiesResponseToJSON(value?: UpdateUserAuthoritiesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'userAuthorities': ((value.userAuthorities as Array<any>).map(UserAuthorityTypeToJSON)),
    };
}


